import appConfig from "@/configs/app.config";
import { REDIRECT_URL_KEY } from "@/constants/app.constant";
import { Navigate, Outlet } from "react-router-dom";
import useUiContext from "@/custolink-hooks/useUiContext";

const { unAuthenticatedEntryPath } = appConfig;

const AdminAreaProtectedRoute = (p: {}) => {
  //const { authenticated } = useAuth()

  const uic = useUiContext()

  const getPathName = `?${REDIRECT_URL_KEY}=${encodeURI(location.href)}`;

  if (!uic.isAuthedAsAdminAreaUser) {
    return <Navigate to={unAuthenticatedEntryPath + getPathName} />;
  }

  //if(am.adminscope == false){
  //        return <Navigate to={appConfig.accessDeniedPath} />
  //  }

  return <Outlet />;
};

export default AdminAreaProtectedRoute;
